export const getIndexMetaData = (context?: any) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.tnt.getIndexMetaData(
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const getTNTEvents = (
  indexID: number,
  startTS: number,
  endTS: number,
  dataArray: string[],
  limit: number,
  asc: boolean,
  timeout: number,
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.tnt.getTNTEvents(
      indexID,
      startTS,
      endTS,
      dataArray,
      limit,
      asc,
      timeout,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const getTNTEventsScrolling = (
  indexID: number,
  startTS: number,
  endTS: number,
  startUid: number,
  dataArray: string[],
  limit: number,
  asc: boolean,
  timeout: number,
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.tnt.getTNTEventsScrolling(
      indexID,
      startTS,
      endTS,
      startUid,
      dataArray,
      limit,
      asc,
      timeout,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const getTNTEventsByID = (ts: number, id: string, context?: any) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.tnt.getTNTEventsByID(
      ts,
      id,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const loadFullTNTEvent = (event: any, context?: any) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.tnt.loadFullTNTEvent(
      event,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const listCounters = (
  tsStart: number,
  tsEnd: number,
  indexId: number,
  data: string[],
  limit: number,
  showIdCount: boolean,
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.tnt.listCounters(
      tsStart,
      tsEnd,
      indexId,
      data,
      limit,
      showIdCount,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const listStockTimes = (
  tsStart: number,
  tsEnd: number,
  indexId: number,
  data: string[],
  limit: number,
  showIdCount: boolean,
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.tnt.listStockTimes(
      tsStart,
      tsEnd,
      indexId,
      data,
      limit,
      showIdCount,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const listCountersMulti = (
  tsStart: number,
  tsEnd: number,
  indexId: number,
  data: string[][],
  limit: number,
  showIdCount: boolean,
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.tnt.listCountersMulti(
      tsStart,
      tsEnd,
      indexId,
      data,
      limit,
      showIdCount,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const listStockTimesMulti = (
  tsStart: number,
  tsEnd: number,
  indexId: number,
  data: string[][],
  limit: number,
  showIdCount: boolean,
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.tnt.listStockTimesMulti(
      tsStart,
      tsEnd,
      indexId,
      data,
      limit,
      showIdCount,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const loadChildren = (ts: number, id: string, context?: any) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.tnt.loadChildren(
      ts,
      id,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const loadChildrenMulti = (ts: number, ids: string[], context?: any) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.tnt.loadChildrenMulti(
      ts,
      ids,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const loadParentsAndChildren = (
  ts: number,
  id: string,
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.tnt.loadParentsAndChildren(
      ts,
      id,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}
